module.exports = __webpack_public_path__ + "static/media/iconVisitActive.f88182a6.svg";